import React from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from 'components/CustomButtons/Button.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardFooter from 'components/Card/CardFooter.jsx';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Field, Form, Formik } from 'formik';
import { username as usernameSchema } from '../../../bus/forms/shapes';
import CustomInputFormik from '../../../components/CustomInputFormik/CustomInputFormik';
import UserIcon from '../../../assets/rainmaker-icons/Rainmaker_soft_icon_37_User.svg';
import SvgIcon from '@material-ui/core/SvgIcon';

export default class UsernameForm extends React.Component {
    constructor (props) {
        super(props);
        this.state = {};
    }

    render () {

        const { classes, username, handleSubmitCheckUser, isFetching } = this.props;

        return (
            <Formik
                initialValues = { {'username': username }}
                isInitialValid={true}
                validationSchema = {usernameSchema.schema}
                onSubmit={handleSubmitCheckUser}
                render={ props => {
                    return (
                        <Form>
                            <Card login>
                                <CardHeader
                                    className={`${classes.cardHeader} ${classes.textCenter}`}
                                    color='info'
                                >
                                    <h4 className={classes.cardTitle}>Log in</h4>
                                </CardHeader>
                                <CardBody>
                                    <Field
                                        name='username'
                                        labelText='Username'
                                        formControlProps={{ fullWidth: true }}
                                        disabled = { isFetching }
                                        inputProps={{
                                            autoFocus: true,
                                            endAdornment: (
                                                <InputAdornment position='end'>
                                                    <SvgIcon component = 'i'>
                                                        <img src={UserIcon} alt='user'/>
                                                    </SvgIcon>
                                                </InputAdornment>
                                            ),
                                        }}
                                        component={CustomInputFormik}
                                    />
                                </CardBody>
                                <CardFooter className={classes.justifyContentCenter}>
                                    <Button
                                        type={'submit'}
                                        color='primary'
                                        simple size='lg'
                                        block
                                        disabled={isFetching || !props.isValid}
                                    >Next
                                    </Button>
                                </CardFooter>
                                {isFetching && <LinearProgress />}
                            </Card>
                        </Form>
                    );
                } }
            />
        );
    }
}
